var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPluginTrash = function SvgPluginTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.67 7.22-.93 12.5c-.08 1.078-1.013 1.912-2.138 1.912H7.736c-1.124 0-2.058-.834-2.138-1.912L4.67 7.22m5.357 4.118v6.177m4.286-6.177v6.177M15.383 7.22V4.13c0-.569-.48-1.03-1.071-1.03h-4.286c-.592 0-1.071.461-1.071 1.03V7.22m-5.357 0H20.74"
  })));
};
export default SvgPluginTrash;